import { render, staticRenderFns } from "./EditShiftPage.vue?vue&type=template&id=fa215dac&"
import script from "./EditShiftPage.vue?vue&type=script&lang=js&"
export * from "./EditShiftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports